import { useMemo } from "react";
import { Stack } from "@mui/material";

import WGRShopGroup from "./c6Group";
import WGRGrandTotal from "./c6GrandTotal";

export default function WGRViewer({ rows ,grandTotal,summary}) {
  /*
   * Group data by SHOP
   */
  const groupedData = useMemo(() => {
    const map = {};

    rows.forEach((row) => {
      const shop = row.ReportType;

      if (!map[shop]) {
        map[shop] = [];
      }

      map[shop].push(row);
    });

    return Object.keys(map)
      .sort((a, b) => Number(a) - Number(b))
      .map((shop) => ({
        shop,
        rows: map[shop],
      }));
  }, [rows]);

    
  return (
    <Stack >




      {groupedData.map((group) => (
        <WGRShopGroup
          key={group.shop}
          shop={group.shop}
          rows={group.rows}
        />
      ))}

    
<WGRGrandTotal
  totals={rows}
  summary={summary}
/>




    </Stack>
  );
}